import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

// Text that reveals word-by-word as user scrolls through it (light -> white)
export default function RevealText({ text, className = '', spaced = false, scrollProgress = null }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start 0.85', 'end 0.35'],
  });

  const actualProgress = scrollProgress || scrollYProgress;
  const words = text.split(' ');

  return (
    <p ref={ref} className={`${className} flex flex-wrap`}>
      {words.map((w, i) => {
        const start = i / words.length;
        const end = start + 1 / words.length;
        return (
          <Word key={i} progress={actualProgress} range={[start, end]} spaced={spaced}>
            {w}
          </Word>
        );
      })}
    </p>
  );
}

function Word({ children, progress, range, spaced }) {
  const opacity = useTransform(progress, range, [0, 1]);
  return (
    <span className="relative mr-[0.35em] mb-[0.1em]">
      <span className="absolute opacity-5">{spaced ? spacedChars(children) : children}</span>
      <motion.span style={{ opacity }}>{spaced ? spacedChars(children) : children}</motion.span>
    </span>
  );
}

function spacedChars(word) {
  return word.split('').map((c, i) => (
    <span key={i} className="mx-[0.08em]">
      {c}
    </span>
  ));
}
